<template>
  <div class="container horizontal-layout">
    <div class="horizontal-scroll-wrapper" :class="{'blend': canScrollRight}" ref="scrollerWrap">
      <div class="horizontal-scroll-container" ref="scroller" @scroll="onScroll">
        <div class="row flex-nowrap w-100 align-items-center">
          <div class="col col-fixed" v-for="(media, index) in medias" :key="index">
            <Media :media="media"
                   :index="index"
                   :is-paid="isPaid"
                   :digital-item-id="digitalItemId"
                   :gallery="gallery"
                   @firstVisible="$emit('nextPage')"
                   @select="$emit('select', $event)"/>
          </div>
          <!-- Load more sentinel -->
          <div ref="sentinel" class="sentinel" v-show="hasNextPage">
            <view-loader :padding-classes="'py-0'" v-if="loading"/>
          </div>
        </div>
      </div>
      <div ref="swipeHelp" :class="{'is-hidden': hideHelp}" class="swipe-help d-md-none" v-if="canScrollRight">
        <img src="@/assets/misc/swipe-left.gif"></div>
    </div>
    <div class="navigation mb-2 d-none d-md-flex" v-if="canScrollLeft || canScrollRight">
      <b-link @click="scroll('left')" :disabled="!canScrollLeft">
        <Icon name="chevronLeft" width="24"/>
      </b-link>
      <b-link @click="scroll('right')" :disabled="!canScrollRight" class="ml-2">
        <Icon name="chevronRight" width="24"/>
      </b-link>
    </div>
  </div>
</template>


<script>
import ViewLoader from "@/components/ViewLoader.vue";
import Media from "@/domain/galleries/medias/Media.vue";

export default {
  name: "HorizontalMedias",
  components: {Media, ViewLoader},
  emits: ['nextPage', 'select'],
  data() {
    return {
      canScrollLeft: false,
      canScrollRight: false,
      hideHelp: false,
      previousScrollLeft: 0 // Used to determine scroll direction
    }
  },
  props: {
    medias: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    pagination: {
      type: Object,
      required: false
    },
    isPaid: {
      type: Boolean,
      required: false
    },
    digitalItemId: {
      type: Number,
      required: false
    },
    gallery: {
      type: Object,
      required: false
    }
  },
  computed: {
    hasNextPage() {
      return this.pagination.page_number <  this.pagination.num_pages
    }
  },
  mounted() {
    this.createObserver();
    this.onScroll({type: 'scroll'}, {isInitialState: true});

    window.addEventListener('resize', () => {
      this.onScroll({type: 'resize'}, {isInitialState: true});
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onScroll);
  },
  methods: {
    createObserver() {
      const options = {
        threshold: [1]
      };
      const observer = new IntersectionObserver(this.handleIntersect, options);
      observer.observe(this.$refs.sentinel);
    },

    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$emit('nextPage')
        }
      })
    },
    scroll(direction) {
      const elScrollableWrap = this.$refs.scrollerWrap
      const elScrollable = this.$refs.scroller
      let scrollAmount = elScrollableWrap.offsetWidth * 0.5 // 50% of the available scroll width
      elScrollable.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      })
    },
    onScroll($event, args = {isInitialState: false}) {
      const elScrollableWrap = this.$refs.scrollerWrap
      const elScrollable = this.$refs.scroller
      const tolerance = 40

      if (!elScrollable || !elScrollableWrap) return

      if ((elScrollable.scrollLeft !== this.previousScrollLeft) || args.isInitialState) {
        this.canScrollLeft = elScrollable.scrollLeft > tolerance
        this.canScrollRight = elScrollable.scrollLeft + elScrollableWrap.offsetWidth < elScrollable.scrollWidth - tolerance

        if (!args.isInitialState) this.hideHelp = true
        this.previousScrollLeft = elScrollable.scrollLeft
      }
    }
  }
}
</script>


<style scoped>

</style>